import { createContext, useContext, useState, type ReactNode } from "react";
import { useStore } from "zustand";
import {
  createShellChrome,
  NOOP_SHELL_CHROME,
  type ShellChrome,
  type ShellRegion,
  type ShellSlotState,
} from "./shellChrome";

const ShellChromeContext = createContext<ShellChrome | null>(null);

export function ShellProvider({ children }: { children: ReactNode }) {
  const [chrome] = useState(createShellChrome);

  return <ShellChromeContext.Provider value={chrome}>{children}</ShellChromeContext.Provider>;
}

export function useShellChrome(): ShellChrome {
  const chrome = useContext(ShellChromeContext);

  if (!chrome) throw new Error("Shell slots are only available inside a ShellProvider");
  return chrome;
}

/** The chrome of the enclosing shell, or a no-op set for components rendered outside one. */
export function useOptionalShellChrome(): ShellChrome {
  return useContext(ShellChromeContext) ?? NOOP_SHELL_CHROME;
}

export function useShellSlot(chrome: ShellChrome, region: ShellRegion): ShellSlotState {
  return useStore(chrome.store, (state) => state.regions[region]);
}
